export function percentChange(current: number, previous: number): number | undefined {
  if (current === 0 || previous === 0) {
    return undefined;
  }

  return Math.round(((current - previous) / previous) * 100);
}
